import type { Template } from "@/types";

export const LA_05_H1_V4: Template[] = [
    {
        id: "la-05-h1v4-01",
        name: "LA 01 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 43, y: 60, width: 589, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 846, y: 38, width: 164, height: 229, rotation: 0, imageRotation: 0 },
            { id: "3", x: 846, y: 275, width: 164, height: 228, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 38, width: 164, height: 229, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 275, width: 164, height: 228, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-02",
        name: "LA 02 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 81, y: 86, width: 514, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 811, y: 58, width: 293, height: 425, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1111, y: 58, width: 108, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1111, y: 203, width: 108, height: 136, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1111, y: 347, width: 108, height: 136, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-03",
        name: "LA 03 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 128, y: 32, width: 420, height: 267, rotation: 0, imageRotation: 0 },      
            { id: "2", x: 128, y: 306, width: 135, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 271, y: 306, width: 135, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 414, y: 306, width: 134, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 848, y: 32, width: 333, height: 478, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-05-h1v4-04",
        name: "LA 04 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 94, y: 57, width: 278, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 380, y: 57, width: 201, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 380, y: 194, width: 201, height: 290, rotation: 0, imageRotation: 0 },
            { id: "4", x: 769, y: 80, width: 241, height: 382, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 80, width: 241, height: 382, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-05",
        name: "LA 05 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 104, y: 89, width: 230, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 89, width: 230, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 771, y: 57, width: 278, height: 427, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1057, y: 57, width: 201, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1057, y: 194, width: 201, height: 290, rotation: 0, imageRotation: 0 } 
        ],
    },

    {
        id: "la-05-h1v4-06",
        name: "LA 06 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 190, y: 57, width: 297, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 825, y: 258, width: 378, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 825, y: 57, width: 121, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 954, y: 57, width: 121, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1083, y: 57, width: 121, height: 192, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-07",
        name: "LA 07 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 62, width: 626, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 634, y: 62, width: 282, height: 418, rotation: 0, imageRotation: 0 },
            { id: "3", x: 924, y: 62, width: 136, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 924, y: 274, width: 136, height: 206, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 62, width: 284, height: 418, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-08",
        name: "LA 08 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 62, width: 626, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 634, y: 62, width: 282, height: 418, rotation: 0, imageRotation: 0 },
            { id: "3", x: 924, y: 62, width: 284, height: 418, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1216, y: 62, width: 136, height: 205, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1216, y: 274, width: 136, height: 205, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-09",
        name: "LA 09 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 35, width: 676, height: 470, rotation: 0, imageRotation: 0 },
            { id: "2", x: 842, y: 35, width: 169, height: 231, rotation: 0, imageRotation: 0 },
            { id: "3", x: 842, y: 274, width: 169, height: 231, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1019, y: 35, width: 168, height: 231, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1019, y: 274, width: 168, height: 231, rotation: 0, imageRotation: 0 }
        ],
    }
];